import React from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../atoms/button/LinkButton';
import Flight from './Flight';

import PlanContent from './PlanContent';
import ItinerarySchedule from './ItinerarySchedule';
import ItineraryPlanOption from './ItineraryPlanOption';
import PlanDateTitle from '../atoms/titles/PlanDateTitle';
import { ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';

const SubscriptionPlanContentsItem = ({
  index,
  outboundFlight,
  inboundFlight,
  dateDisplay,
  plan,
  handleOutboundFlightChange,
  handleInboundFlightChange,
  handlePlanChange,
  handlePlanDelete,
  cantChangeFlight,
  cantChangeHotel,
  cantDeleteHotel,
  handleUpdateCheckin,
  finalConfirm,
  hideCheckin,
  handleUpdateQuestion,
  showQuestions,
  hideMessage,
  planOptions,
  questionAndAnswers,
  onQuestionAnswerChange,
  previousIsPlanOption,
}) => {

  let message = '';
  if (plan && plan.hotel) {
    message = plan.hotel.message;
  }

  const accessCaution = (
    <div style={{ margin: '15px auto 0', maxWidth: 350, fontSize: '10px' }}>
      ※空港～宿泊施設間のアクセス・所要時間は、お客様ご自身でご確認ください。<br/>
      <span className="textRed">（現地移動につきましてはお客様負担となります）</span>
    </div>
  );

  const content = inboundFlight ? (
    <React.Fragment>
      {(planOptions && planOptions.length > 0) && (
      <div className="subscriptionPlanContentItem">
        <PlanContent title={'タビサキMenu'}>
          <ItineraryPlanOption
            SP
            finalConfirm={finalConfirm}
            planOptions={planOptions}
            hideCheckin={hideCheckin}
            hideMessage={hideMessage}
            handleUpdateCheckin={handleUpdateCheckin}
            showQuestions={showQuestions}
            handleUpdateQuestion={handleUpdateQuestion}
            questionAndAnswers={questionAndAnswers}
            onQuestionAnswerChange={onQuestionAnswerChange}
          />
          {message && !hideMessage && (
            <div className="planAttention">
              <div className="title">施設に関するご案内・ご注意</div>
              <div className="detail">
                {message}
              </div>
            </div>
          )}
        </PlanContent>
      </div>
      )}

      <div className="subscriptionPlanContentItem">
        <PlanContent title={'帰り'}>
          <div className="subscriptionPlanContentInner">
            <Flight seat={false} flight={inboundFlight} />
            {!cantChangeFlight && (
              <div className="subscriptionPlanContentInnerButton">
                <LinkButton onClick={handleInboundFlightChange}>利用便を変更する</LinkButton>
              </div>
            )}
            {accessCaution}
          </div>
        </PlanContent>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      {outboundFlight && (
        <div className="subscriptionPlanContentItem">
          <PlanContent title={'行き'}>
            <div className="subscriptionPlanContentInner">
              <Flight seat={false} flight={outboundFlight} />
              {!cantChangeFlight && (
                <div className="subscriptionPlanContentInnerButton">
                  <LinkButton onClick={handleOutboundFlightChange}>利用便を変更する</LinkButton>
                </div>
              )}
              {accessCaution}
            </div>
          </PlanContent>
        </div>
      )}

{(planOptions && planOptions.length > 0) && (
      <div className="subscriptionPlanContentItem">
        <PlanContent title={'タビサキMenu'}>
          <ItineraryPlanOption
            SP
            finalConfirm={finalConfirm}
            planOptions={planOptions}
            hideCheckin={hideCheckin}
            hideMessage={hideMessage}
            handleUpdateCheckin={handleUpdateCheckin}
            showQuestions={showQuestions}
            handleUpdateQuestion={handleUpdateQuestion}
            questionAndAnswers={questionAndAnswers}
            onQuestionAnswerChange={onQuestionAnswerChange}
          />
          {message && !hideMessage && (
            <div className="planAttention">
              <div className="title">施設に関するご案内・ご注意</div>
              <div className="detail">
                {message}
              </div>
            </div>
          )}
        </PlanContent>
      </div>
)}
      <div className="subscriptionPlanContentItem">
        <PlanContent title={'宿泊'}>
          {plan ? (
            <React.Fragment>
              <ItinerarySchedule
                SP
                finalConfirm={finalConfirm}
                plan={plan}
                hideCheckin={hideCheckin}
                hideMessage={hideMessage}
                handleUpdateCheckin={handleUpdateCheckin}
                showQuestions={showQuestions}
                handleUpdateQuestion={handleUpdateQuestion}
              />
              {!cantChangeHotel && (
                <React.Fragment>
                  <div className="planButton">
                    {index !== 1 && cantDeleteHotel && <LinkButton onClick={handlePlanChange}>宿泊プランを変更する</LinkButton>}
                    {index !== 1 && cantDeleteHotel && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
                  </div>
                  {!cantDeleteHotel && (
                    <div className="planButton mt-15">
                      <LinkButton onClick={handlePlanDelete}>宿泊施設を削除する</LinkButton>
                    </div>
                  )}
                </React.Fragment>
              )}
              {message && !hideMessage && (
                <div className="planAttention">
                  <div className="title">施設に関するご案内・ご注意</div>
                  <div className="detail">
                    {message}
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
            <div className="noPlan">
              <div className="noPlanText">{ENABLE_MULTIPLE_HOTEL_PLAN ? '宿泊プランが設定されていません' : 'ご宿泊に関しては、お客様ご自身で別途手配が必要となります'}</div>
              {ENABLE_MULTIPLE_HOTEL_PLAN && (
                <div className="planButton">
                  <LinkButton onClick={handlePlanChange}>宿泊内容を追加する</LinkButton>
                  {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
                </div>
              )}
              {!previousIsPlanOption && (
                <div className="mt-15 itineraryCaution">※当社の手配による旅行サービスが一切行われない日(無手配日)は、特別補償の対象外となります。</div>
              )}
            </div>
          )}
        </PlanContent>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="subscriptionPlanContent">
        <PlanDateTitle date={dateDisplay}>
          {index}日目
        </PlanDateTitle>
        {content}
      </div>
    </React.Fragment>
  );
};

SubscriptionPlanContentsItem.propTypes = {
  index: PropTypes.number.isRequired,
  outboundFlight: PropTypes.object,
  inboundFlight: PropTypes.object,
  dateDisplay: PropTypes.string,
  plan: PropTypes.object,
  handleOutboundFlightChange: PropTypes.func.isRequired,
  handleInboundFlightChange: PropTypes.func.isRequired,
  handlePlanChange: PropTypes.func.isRequired,
  handlePlanDelete: PropTypes.func.isRequired,
  cantChangeFlight: PropTypes.bool,
  cantChangeHotel: PropTypes.bool,
  cantDeleteHotel: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  finalConfirm: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  hideMessage: PropTypes.bool,
  planOptions: PropTypes.array,
  questionAndAnswers: PropTypes.array,
  onQuestionAnswerChange: PropTypes.func,
  previousIsPlanOption: PropTypes.bool,
};

export default SubscriptionPlanContentsItem;
